// extracted by mini-css-extract-plugin
module.exports = {"text-separator":"text-separator-1YZYQZXhvEeN0qxYabbxQ7","textSeparator":"text-separator-1YZYQZXhvEeN0qxYabbxQ7"};